// extracted by mini-css-extract-plugin
module.exports = {"listReviews":"list-reviews-module--listReviews--JhiIU"};